import { PhoneIcon, ZaloIcon } from '@/assets/icons';
import React from 'react';

const PopupCircle = () => {
  const handlePhoneClick = () => {
    window.location.href = 'tel:0834194986';
  };

  const handleZaloClick = () => {
    window.open('https://zalo.me/0834194986', '_blank');
  };

  const handlePhoneKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handlePhoneClick();
    }
  };

  const handleZaloKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleZaloClick();
    }
  };

  return (
    <div className="fixed bottom-5 right-5 flex flex-col gap-5 z-50">
      <div 
        className="h-16 w-16 bg-secondary z-50 rounded-full flex relative justify-center items-center shadow-xl duration-300 cursor-pointer before:absolute before:inset-0 before:w-full before:h-full before:rounded-full before:bg-secondary before:animate-ping hover:scale-105"
        onClick={handlePhoneClick}
        onKeyDown={handlePhoneKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Gọi điện thoại 083 419 4986"
      >
        <PhoneIcon />
      </div>
      <div 
        className="h-16 w-16 bg-primary z-50 rounded-full flex relative justify-center items-center shadow-xl duration-300 cursor-pointer before:absolute before:inset-0 before:w-full before:h-full before:rounded-full before:bg-primary before:animate-ping hover:scale-105"
        onClick={handleZaloClick}
        onKeyDown={handleZaloKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Nhắn tin Zalo 083 419 4986"
      >
        <ZaloIcon/>
      </div>
    </div>
  );
};

export default PopupCircle;
